<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="category">
      <mask
        id="mask0_77_7902"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect id="Bounding box" width="20" height="20" fill="currentColor" />
      </mask>
      <g mask="url(#mask0_77_7902)">
        <path
          id="category_2"
          d="M5.41667 9.16675L10 1.66675L14.5833 9.16675H5.41667ZM14.5833 18.3334C13.5417 18.3334 12.6562 17.9688 11.9271 17.2397C11.1979 16.5105 10.8333 15.6251 10.8333 14.5834C10.8333 13.5417 11.1979 12.6563 11.9271 11.9272C12.6562 11.198 13.5417 10.8334 14.5833 10.8334C15.625 10.8334 16.5104 11.198 17.2396 11.9272C17.9688 12.6563 18.3333 13.5417 18.3333 14.5834C18.3333 15.6251 17.9688 16.5105 17.2396 17.2397C16.5104 17.9688 15.625 18.3334 14.5833 18.3334ZM2.5 17.9167V11.2501H9.16667V17.9167H2.5ZM14.5833 16.6667C15.1667 16.6667 15.6597 16.4654 16.0625 16.0626C16.4653 15.6598 16.6667 15.1667 16.6667 14.5834C16.6667 14.0001 16.4653 13.507 16.0625 13.1042C15.6597 12.7015 15.1667 12.5001 14.5833 12.5001C14 12.5001 13.5069 12.7015 13.1042 13.1042C12.7014 13.507 12.5 14.0001 12.5 14.5834C12.5 15.1667 12.7014 15.6598 13.1042 16.0626C13.5069 16.4654 14 16.6667 14.5833 16.6667ZM4.16667 16.2501H7.5V12.9167H4.16667V16.2501ZM8.375 7.50008H11.625L10 4.87508L8.375 7.50008Z"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
